module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.logoWrapper)+'"></div>';return out;
} 
  };